import React, { useCallback, useEffect, useState } from "react"
import { useRecoilState } from "recoil"
import layoutStates from "../../recoil/atoms/layout"

// This Hook listen to screen size change events and update the size in recoil
export function useWindowSizeListener({ ignoreChange = false } = {}) {
  const [screenSize, setScreenSize] = useRecoilState(
    layoutStates.screenSizeSelector
  )

  function handleResize() {
    // Set window width/height to state
    setScreenSize({
      width: window.innerWidth,
      height: window.innerHeight
    })
  }


  useEffect(() => {
    window.addEventListener("orientationchange", handleResize)

    return () => window.removeEventListener("orientationchange", handleResize)
  }, [])

  useEffect(() => {
    // Handler to call on window resize
    if (ignoreChange) return
    // Add event listener
    window.addEventListener("resize", handleResize)

    // Call handler right away so state gets updated with initial window size
    handleResize()

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, []) // Empty array ensures that effect is only run on mount

  return { screenSize, setScreenSize }
}

// This Hook returns current screen size
function useWindowSize() {
  const [screenSize, setScreenSize] = useRecoilState(
    layoutStates.screenSizeSelector
  )

  // This method update the latest window.innerWidth and window.innerHeight
  const refreshScreenSize = useCallback(() => {
    setScreenSize({
      width: window.innerWidth,
      height: window.innerHeight
    })
  }, [])

  return { screenSize, setScreenSize, refreshScreenSize }
}

export function useWindowSizeLocal() {
  const [size, setSize] = useState<{ width: number; height: number } | null>(
    null
  )

  function handleResize() {
    setSize({
      width: window.innerWidth,
      height: window.innerHeight
    })
  }

  useEffect(() => {
    handleResize()
    window.addEventListener("resize", handleResize)
    window.addEventListener("orientationchange", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
      window.removeEventListener("orientationchange", handleResize)
    }
  }, [])

  return size
}

export default useWindowSize;
